import { JOBS, TEMPLATES, INVOICES, SUPPLIES, SAMPLES, PREPAID_REQUESTS } from './apis';

const defaultGroupSettings = {
  abortController: new AbortController(),
  shouldLoad: false,
  isLoading: false,
  pageSize: 25,
  pageNumber: 1,
  data: [],
  keys: undefined,
  keyPairs: undefined,
  searchParams: {},
  globalSearchParams: {},
  defaultKeys: [],
  requiredFields: [],
};

const tables = {
  overviewJobs: {
    abortController: new AbortController(),
    ...defaultGroupSettings,
    viewCode: 'overviewJobs',
    code: 'jobs',
    title: 'Jobs',
    requiredFields: [
      'Submitted',
      'ReceivedDate',
      'Status',
      'SubmissionId',
      'RecievedData',
      'ECoCNumber',
      'MaxxamJobNumber',
      'PrepaidRequest',
      'RequestStatus',
    ],
    URL: JOBS,
    pageSize: 3,
    pageNumber: 0,
  },
  overviewTemplates: {
    abortController: new AbortController(),
    ...defaultGroupSettings,
    viewCode: 'overviewTemplates',
    code: 'templates',
    title: 'eCOC Templates',
    requiredFields: [
      'Pinned',
      'MyTemplate',
      'Id',
      'LockTemplate',
      'Description',
      'CreatedByName',
      'SubmissionTypeId',
      'CreatedDate',
      'SiteNumber',
      'POAFENumber',
      'ProjectNumber',
      'HasCompositeSamples',
    ],

    sort: '-Pinned,-ModifiedDate',
    URL: TEMPLATES,
    pageSize: 3,
    pageNumber: 0,
  },
  overviewInvoices: {
    abortController: new AbortController(),
    ...defaultGroupSettings,
    viewCode: 'overviewInvoices',
    requiredFields: ['AmountRemaining', 'IsPayable'],
    code: 'invoices',
    title: 'Invoices',
    URL: INVOICES,
    pageSize: 3,
  },
  overviewOrders: {
    abortController: new AbortController(),
    ...defaultGroupSettings,
    viewCode: 'overviewOrders',
    code: 'supplies',
    title: 'Supplies',
    requiredFields: ['OrderNumber', 'Pinned', 'Status', 'Waybill', 'CreatedBy', 'Shipped', 'Placed', 'ProjectNumber'],
    sort: '-Pinned,-Placed',
    URL: SUPPLIES,
    pageSize: 3,
    pageNumber: 0,
  },
  jobs: {
    abortController: new AbortController(),
    ...defaultGroupSettings,
    viewCode: 'jobs',
    code: 'jobs',
    title: 'Jobs',
    sort: '-ReceivedDate,-MaxxamJobNumber',
    requiredFields: [
      'Submitted',
      'ReceivedDate',
      'Status',
      'SubmissionId',
      'RecievedData',
      'ECoCNumber',
      'PrepaidRequest',
      'RequestStatus',
      'IsPrepaidJob',
      'IsPrepaidOrder',
      'ContactEmail',
    ],
    tabIndex: 0,
    searchParams: {
      Received: true,
    },
    globalSearchParams: {},
    URL: JOBS,
  },
  invoices: {
    abortController: new AbortController(),
    ...defaultGroupSettings,
    viewCode: 'invoices',
    code: 'invoices',
    title: 'Columns',
    requiredFields: [
      'PrefixInvoiceNumber',
      'AmountRemaining',
      'InvoiceDate',
      'InvoiceNumber',
      'Jobs',
      'MaxxamJobNumber',
      'Attention',
      'ReceivedDate',
      'ProjectNumber',
      'SiteLocation',
      'SiteNumber',
      'IsPayable',
    ],
    tabIndex: 0,
    searchParams: {
      paid: 'NO',
    },
    globalSearchParams: {},
    URL: INVOICES,
    sort: '-InvoiceDate',
    selectedInvoices: [],
    paySingleInvoice: false,
    singlePayInvoiceNumber: undefined,
    OrderId: undefined,
  },
  orders: {
    abortController: new AbortController(),
    ...defaultGroupSettings,
    viewCode: 'orders',
    title: 'Supplies',
    code: 'orders',
    isInitialized: false,
    sort: '-Placed',
    requiredFields: ['OrderNumber', 'Pinned', 'Status', 'Waybill', 'CreatedBy', 'Shipped', 'Placed', 'ProjectNumber'],
    tabIndex: 0,
    searchParams: {
      Pinned: true,
    },
    globalSearchParams: {},
    URL: SUPPLIES,
  },
  templates: {
    abortController: new AbortController(),
    ...defaultGroupSettings,
    viewCode: 'templates',
    isInitialized: false,
    code: 'templates',
    title: 'eCOC Templates',
    URL: TEMPLATES,
    requiredFields: [
      'Pinned',
      'MyTemplate',
      'Id',
      'LockTemplate',
      'Description',
      'CreatedByName',
      'SubmissionTypeId',
      'CreatedDate',
      'SiteNumber',
      'POAFENumber',
      'ProjectNumber',
      'HasCompositeSamples',
    ],
    tabIndex: 0,
    searchParams: {
      Pinned: true,
    },
    globalSearchParams: {},
    sort: '-ModifiedDate',
  },
  sampleDetails: {
    abortController: new AbortController(),
    viewCode: 'SampleDetails',
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
  },
  jobDetails: {
    abortController: new AbortController(),
    viewCode: 'JobDetails',
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
  },
  parameters: {
    abortController: new AbortController(),
    viewCode: 'Parameters',
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
  },
  jobFiles: {
    abortController: new AbortController(),
    viewCode: 'JobFiles',
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
  },
  ordersSearch: {
    abortController: new AbortController(),
    viewCode: 'ordersSearch',
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
  },
  observations: {
    abortController: new AbortController(),
    viewCode: 'Observations',
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
  },
  receivedJobs: {
    abortController: new AbortController(),
    viewCode: 'receivedJobs',
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
    requiredFields: ['MaxxamJobNumber'],
  },
  prepaidAll: {
    abortController: new AbortController(),
    viewCode: 'prepaidAll',
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
    requiredFields: ['MaxxamJobNumber'],
  },
  submittedTab: {
    abortController: new AbortController(),
    viewCode: 'submittedTab',
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
  },
  additionTab: {
    abortController: new AbortController(),
    viewCode: 'additionTab',
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
  },
  reportJobs: {
    abortController: new AbortController(),
    viewCode: 'ReportJobs',
    requiredFields: ['MaxxamJobNumber'],
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
  },
  invoiceJobs: {
    abortController: new AbortController(),
    viewCode: 'invoiceJobs',
    handleDataManually: true,
    keys: undefined,
    keyPairs: undefined,
  },
  samples: {
    abortController: new AbortController(),
    ...defaultGroupSettings,
    viewCode: 'SampleResults',
    code: 'samples',
    title: 'Samples',
    globalSearchParams: {},
    URL: SAMPLES,
  },
  prepaidrequest: {
    abortController: new AbortController(),
    ...defaultGroupSettings,
    viewCode: 'submittedTab',
    code: 'prepaidRequest',
    title: 'Prepaid',
    sort: '-ECoCNumber',
    requiredFields: [
      'Submitted',
      'ReceivedDate',
      'Status',
      'SubmissionId',
      'RecievedData',
      'ECoCNumber',
      'PrepaidRequest',
      'RequestStatus',
      'IsPrepaidJob',
      'IsPrepaidOrder',
      'ContactEmail',
    ],
    tabIndex: 0,
    searchParams: {
      RequestStatus: 'D',
    },
    globalSearchParams: {},
    URL: PREPAID_REQUESTS,
  },
  splitReport: {
    abortController: new AbortController(),
    viewCode: 'splitReport',
    handleDataManually: true,
    requiredFields: ['RequestNumber', 'JobNumber'],
    defaultKeys: ['RequestNumber', 'JobNumber'],
    keys: undefined,
    keyPairs: undefined,
  },
};

export default tables;



// WEBPACK FOOTER //
// ./src/constants/tables.js